module.exports = __webpack_public_path__ + "4f93b57a6df042d94ec08736ef90c357.pdf";